import React from "react";
import { Link } from "react-router-dom";

import "./styleContact.css";
export function Contact(){
  const hiperAncle = { textDecoration: "none" };
  const paragraph_botton = { marginBottom: "5%" };
  return (
    <div className="container-contact" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
      <section className="in-container__section">
        <h3>ADMINISTRACIÓN</h3>
        <div className="div_Email"><span>Email</span><p>Droommk12@Gmail.com</p>
          <Link to={"https://mail.google.com"}target="_blank"style={hiperAncle}><p>Ir a Gmail</p></Link>
          <Link to={"mailto:droommk12@gmail.com"}style={hiperAncle}target="_blank">
            <p style={paragraph_botton} title="CORONADOS POR EL BIEN" >Enviar un correo electrónico</p>
          </Link><br/>
        </div>
        <div className="div_phone">
          <span>Teléfono</span>
          <Link to={"tel:0054-24915-4213965"} style={hiperAncle}>
            <p style={paragraph_botton} title="CORONADOS POR EL BIEN">0054 <code>(arg)</code>-2494 213965</p>
          </Link><br/>
        </div>
        <div className="div_whatsapp"> 
          <span>WhatsApp</span>
          <Link to={"https://wa.me/542494213965"}target="_blank"style={hiperAncle}>
            <p style={paragraph_botton} title="CORONADOS POR EL BIEN">0054 <code>(arg)</code>-2494 213965 <br />Enviar WhatsApp</p>
          </Link><br/>
        </div>
        <div className="div_divBox">
          <span>Colaboración</span>
          <p>Alias: PISTA.BARRO.AUGE</p><p title="CORONADOS POR EL BIEN">PayPal Through email: Punkcer@hotmail.com</p><br/>
        </div>
      </section>
      <section style={{display:"block", width:"100%" ,height:"120px"}}> 
        <h6 style={{textAlign:"center",margin:"auto"}}>Redes sociales</h6>
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", width:"95%", height:"30%" ,gap:"5%",backgroundColor:"black" ,margin:"auto"}}>
            <Link to={"https://www.facebook.com/CoronadosDelBien"}   target="_blank"style={hiperAncle}>
          <article style={{cursor:"pointer" ,color:"white" }} >Facebook</article>
            </Link>
          <Link to={"https://x.com/GlassDroom"} target="_blank"style={hiperAncle}>
           <article style={{cursor:"pointer" ,color:"white" }}>Red X</article>
          </Link>   
         <Link to={"https://www.youtube.com/@MartinICere"} target="_blank"style={hiperAncle}>
               <article style={{cursor:"pointer" ,color:"white" }}>You Tube</article>
         </Link>
        </div>
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", width:"95%", height:"40%" , gap:"4%",backgroundColor:"black" ,margin:"auto"}}>
          <Link to={"https://www.threads.com/@droommk12?xmt=AQG0dfU6qK0e4ycVV1NQVhoWZvSPsPc9XXDbj3U_Wmp2eXM"} target="_blank"style={hiperAncle}>
            <article style={{cursor:"pointer" ,color:"white" }}>Thread</article>
          </Link>
          <Link to={"https://www.facebook.com/MusicaAr"} target="_blank"style={hiperAncle}>
            <article style={{cursor:"pointer" ,color:"white" }}>FriendBook</article>
          </Link>
        </div>
      </section>
    </div>
  );
}
